import { useState } from 'react';
import { wakeLockOptedOut, setWakeLockOptOut } from '../net/wakelock';

/** Battery-conscious opt-out for the screen Wake Lock (v5/P2 / §20.4). On a
 *  phone, Wake Lock keeps the screen (and GPS) alive during play; opting out
 *  saves battery at the cost of having to keep the screen on yourself. */
export function WakeToggle() {
  const [off, setOff] = useState(wakeLockOptedOut());
  const toggle = () => {
    const next = !off;
    setWakeLockOptOut(next);
    setOff(next);
  };
  return (
    <button
      className="sim-toggle wake-toggle"
      data-active={!off}
      data-testid="wake-toggle"
      onClick={toggle}
      title="Keep the screen awake during a round (battery)"
    >
      <span className={`dot ${off ? '' : 'dot--on'}`} />
      {off ? 'Screen: auto' : 'Screen: on'}
    </button>
  );
}
